<template>
  <div class="inteBox">
    <hd-com></hd-com>
    <div class="titleTopLine"></div>
    <div class="titleTopCenter noflex-l-s">
      <div class="titleTopCenterLeft">
        <div :class="detailInfo.orderType == 2 ? 'left-btn1' : 'left-btn2'" @click="handleClickBtn('2')">在线问诊</div>
        <div :class="detailInfo.orderType == 1 ? 'left-btn1' : 'left-btn2'" @click="handleClickBtn('1')">电话问诊</div>
        <div :class="active == 3 ? 'left-btn1' : 'left-btn2'" @click="handleClickYu('3')">挂号预约</div>
      </div>
      <div class="titleTopCenterCenter">
        <div class="titleTopCenterCenterTop">
          <div class="iq-card-body">
            <div class="table-top flex-space-between">
              <el-page-header @back="goBack" :content="detailInfo.orderType == 2 ? '在线问诊详情' : '电话问诊详情'"> </el-page-header>
              <!-- <div class="flex-end">
                <div style="margin-left: 10px">
                  <el-button type="primary" size="small" @click="toConfirm()" v-if="detailInfo.state == 1">确认接诊</el-button>
                  <template v-if="active == 1 && detailInfo.state == 2">
                    <el-button type="primary" size="small" @click="toContact()" v-if="detailInfo.doctorFinishState == 0">联系患者</el-button>
                    <el-button type="primary" size="small" @click="toContact()" v-if="detailInfo.doctorFinishState == 1 && detailInfo.userFinishState == 2">再次联系患者</el-button>
                  </template>
                  <el-button type="danger" size="small" @click="toRefund()" v-if="detailInfo.state == 1 || detailInfo.state == 2">拒绝接诊</el-button>
                </div>
              </div> -->
            </div>
            <div class="table-line"></div>
            <div class="table-content">
              <div class="top-bg">
                <div class="top-info flex-space-between">
                  <div class="left-i">
                    <div class="flex-start">
                      <img style="width: 40px; height: 40px; border-radius: 50%" :src="`${Services.ossUpload}${detailInfo.photoFile}`" v-if="detailInfo.photoFile" />
                      <img v-else src="@/assets/img/touxiang03.png" />
                      <div style="margin-left: 5px">
                        <div class="flex-start">
                          <div class="doctor-1">{{ detailInfo.doctorName }} {{ detailInfo.departmentName }}</div>
                          <img style="margin-right: 5px" src="@/assets/img/rz_label.png" v-if="detailInfo.certificateNumber" />
                          <div class="doctor-bg2" v-if="detailInfo.userCategoryType == 1">专家</div>
                          <div class="doctor-bg2" v-if="detailInfo.levelName">{{ detailInfo.levelName }}</div>
                        </div>
                        <div class="hosptail">{{ detailInfo.organizationName }}</div>
                      </div>
                    </div>
                    <div class="info-div">
                      <div class="t1">
                        <img style="margin-right: 5px; margin-bottom: -3px" src="@/assets/img/wz_iconP02.png" v-if="detailInfo.orderType == 1" />
                        <img style="margin-right: 5px; margin-bottom: -3px" src="@/assets/img/wz_iconP03.png" v-else />
                        <span style="margin-right: 5px">{{ detailInfo.orderType == 1 ? "电话问诊" : "在线问诊" }}</span>
                        <span style="color: #00afb5; font-weight: bold">￥{{ detailInfo?.totalMoney?.toFixed(2) || 0.0 }}/{{ detailInfo.orderType == 1 ? "一次30分钟" : "次" }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="center-i">
                    <div class="t1">
                      <span class="t2">患者信息：</span>
                      <span class="right-desc"
                        >{{ detailInfo.patientName }} {{ detailInfo.sex ? "男" : "女" }} {{ getAge(detailInfo?.birthday) }}岁（{{ detailInfo.birthday?.split("T")[0] }}）
                        <template v-if="detailInfo.relationshipToPatient == 0">本人</template>
                        <template v-if="detailInfo.relationshipToPatient == 1">子女</template>
                        <template v-if="detailInfo.relationshipToPatient == 2">父母</template>
                        <template v-if="detailInfo.relationshipToPatient == 3">其他</template>
                      </span>
                    </div>
                    <div class="t1">
                      <span class="t2">联系地址：</span>
                      <span class="right-desc">{{ detailInfo.address  || '暂无'}}</span>
                    </div>
                    <div class="t1">
                      <span class="t2">所患疾病：</span>
                      <span class="right-desc">{{ detailInfo.diseaseDiagnose  || '暂无' }}</span>
                    </div>
                  </div>
                  <div class="right-i">
                    <div style="color: #00afb5; font-weight: bold" v-if="detailInfo.state == 0">待支付</div>
                    <div style="color: #00afb5; font-weight: bold" v-if="detailInfo.state == 1">待接诊</div>
                    <div style="color: #00afb5; font-weight: bold" v-if="detailInfo.state == 2">接诊中</div>
                    <div style="color: #00afb5; font-weight: bold" v-if="detailInfo.state == 3">已完成</div>
                    <div style="color: #00afb5; font-weight: bold" v-if="detailInfo.state == -1">已取消</div>
                    <div style="color: #00afb5; font-weight: bold" v-if="detailInfo.state == -2">已退款</div>
                    <div style="color: #00afb5; font-weight: bold" v-if="detailInfo.state == -3">医生拒绝接诊</div>
                    <div style="color: #00afb5; font-weight: bold" v-if="detailInfo.state == -3">{{ detailInfo.refundRefuseReson }}</div>
                    <div style="color: #00afb5; font-weight: bold" v-if="detailInfo.state == -4">删除</div>
                  </div>
                </div>
                <div class="flex-start" style="margin-top: 15px">
                  <div class="top-1">
                    <span>订单编号：</span>
                    <span>{{ detailInfo.orderNumber }}</span>
                  </div>
                  <div class="top-1">
                    <span>下单时间：</span>
                    <span>{{ detailInfo.addTime | timefilters }}</span>
                  </div>
                  <div class="top-1">
                    <span>支付方式：</span>
                    <span v-if="detailInfo.payType == 0">余额</span>
                    <span v-if="detailInfo.payType == 1">微信</span>
                    <span v-if="detailInfo.payType == 2">支付宝</span>
                  </div>
                  <div class="top-1">
                    <span>支付时间：</span>
                    <span>{{ detailInfo.paySuccessTime | timefilters }}</span>
                  </div>
                  <div class="top-1">
                    <span>实付款：</span>
                    <span>合计 ￥ {{ detailInfo.payMoney ? detailInfo.payMoney.toFixed(2) : 0 }}</span>
                  </div>
                </div>
              </div>
              <el-radio-group v-model="infoType" style="margin-top: 20px" @change="handleChange">
                <el-radio-button label="患者病历"></el-radio-button>
                <el-radio-button label="问诊过程" v-if="detailInfo.orderType == 2"></el-radio-button>
              </el-radio-group>
              <div v-if="infoType == '患者病历'" style="height: calc(100vh - 500px); overflow-y: auto">
                <div class="center-div">
                  <div class="flex-start" style="margin-bottom: 8px">
                    <div class="line-left"></div>
                    <h3 style="font-weight: bold">详细病情</h3>
                  </div>
                  <div>
                    <span style="font-weight: bold">病情描述：</span>
                    <span class="hosptail">{{ detailInfo?.description }}</span>
                  </div>
                  <div v-if="detailInfo.diseaseImage.length>0">
                    <span style="font-weight: bold">检查报告/患者处方照片</span>
                    <div class=" flex-start flex-warp">
                      <div v-for="(files,i) in detailInfo.diseaseImage" :key="i">
                        <el-image fit="cover" style="width: 100px;height: 100px;margin-right: 5px;margin-bottom: 5px;" hide-on-click-modal :src="Services.ossUpload + files.filePath" preview-teleported :zoom-rate="1.2" :preview-src-list="[Services.ossUpload + files.filePath]"></el-image>
                      </div>
                    </div>
                  </div>
                  <div>
                    <span style="font-weight: bold">患病时长：</span>
                    <span class="hosptail">{{ detailInfo?.patientAnswerRecordDetailList[1]?.userAnswer[0]?.quesAnsName }}</span>
                  </div>
                  <div v-if="detailInfo?.patientAnswerRecordDetailList[3]?.userAnswer[0]?.quesAnsName == '有'">
                    <span style="font-weight: bold">当前正在使用药物：</span>
                    <span class="hosptail">{{ detailInfo.patientAnswerRecordDetailList[3].userAnswer[0].otherData[0].patientHisDrug  ? detailInfo.patientAnswerRecordDetailList[3].userAnswer[0].otherData[0].patientHisDrug : '暂未填写'}}</span>
                  </div>
                </div>
                <div class="center-div" 
                v-if="detailInfo?.patientAnswerRecordDetailList[4]?.userAnswer[0]?.quesAnsName == '有' || 
                detailInfo?.patientAnswerRecordDetailList[5]?.userAnswer[0]?.quesAnsName == '有' || 
                detailInfo?.patientAnswerRecordDetailList[2]?.userAnswer[0]?.quesAnsName == '就诊过' || 
                detailInfo?.patientAnswerRecordDetailList[6]?.userAnswer[0]?.quesAnsName == '有'
                " 
                >
                  <div class="flex-start" style="margin-bottom: 8px">
                    <div class="line-left"></div>
                    <h3 style="font-weight: bold">既往史</h3>
                  </div>
                  <template v-if="detailInfo?.patientAnswerRecordDetailList[2]?.userAnswer[0]?.quesAnsName == '就诊过'">
                    <div v-for="(item1, index) in detailInfo?.patientAnswerRecordDetailList[2]?.userAnswer[0]?.otherData" :key="index">
                      <div>
                        <span style="font-weight: bold">历史就诊医院：</span>
                        <span class="hosptail">{{ item1.patientHisHos ? item1.patientHisHo : '暂未填写' }}</span>
                      </div>
                      <div >
                        <span style="font-weight: bold">历史就诊科室：</span>
                        <span class="hosptail">{{ item1.patientHisDep ? item1.patientHisDep : '暂未填写'  }}</span>
                      </div>
                    </div>
                  </template>
                  <template v-if="detailInfo?.patientAnswerRecordDetailList[4]?.userAnswer[0]?.quesAnsName == '有'">
                    <div v-for="(item, index) in detailInfo?.patientAnswerRecordDetailList[4]?.userAnswer[0]?.otherData" :key="index">
                      <span style="font-weight: bold">{{ item.name }}：</span>
                      <span class="hosptail">{{ item.des }}</span>
                    </div>
                  </template>
                  <div v-if="detailInfo?.patientAnswerRecordDetailList[5]?.userAnswer[0]?.quesAnsName == '有'">
                    <span style="font-weight: bold">慢性病史：</span>
                    <span class="hosptail">{{ detailInfo.patientAnswerRecordDetailList[5].userAnswer[0].otherData[0].diseasesDes ? detailInfo.patientAnswerRecordDetailList[5].userAnswer[0].otherData[0].diseasesDes : '暂未填写' }}</span>
                  </div>
                  <template v-if="detailInfo?.patientAnswerRecordDetailList[6]?.userAnswer[0]?.quesAnsName == '有'">
                    <div v-for="(item2, index) in detailInfo?.patientAnswerRecordDetailList[6]?.userAnswer[0]?.otherData" :key="index">
                      <span style="font-weight: bold">药物过敏：</span>
                      <span class="hosptail">{{ item2.drugDes ? item2.drugDes : '暂未填写'  }}</span>
                    </div>
                  </template>
                </div>
                <div class="center-div">
                  <div class="flex-start" style="margin-bottom: 8px">
                    <div class="line-left"></div>
                    <h3 style="font-weight: bold">体格检查</h3>
                  </div>
                  <div>
                    <span class="hosptail">{{ detailInfo?.patientAnswerRecordDetailList[0]?.userAnswer[0]?.otherData[0]?.patientHeight }}cm,{{ detailInfo?.patientAnswerRecordDetailList[0]?.userAnswer[0]?.otherData[0]?.patientWeight }}kg({{ detailInfo?.patientAnswerRecordDetailList[0]?.userAnswer[0]?.otherData[0]?.patienTtestTime }}测量)</span>
                  </div>
                </div>
              </div>
              <template v-if="infoType == '问诊过程'">
                <div style="width: 50%; padding: 15px; background: #f0f2f5; margin: 20px 0; border-radius: 8px; height: calc(100vh - 500px)">
                  <chat-history ref="chatHistory" :messages="chatMessages" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="titleTopLine"></div>
    <el-dialog title="拒绝接诊原因" :visible.sync="refuseDialog" width="450px" :append-to-body="true" :z-index="99999">
      <el-form class="dialog-form" :model="refuseForm" ref="refuseForm" :rules="rules" :label-width="formLabelWidth">
        <el-form-item prop="refuseReson">
          <el-input v-model="refuseForm.refuseReson" type="textarea" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="CloseBtn('refuseForm')">取 消</el-button>
        <el-button type="primary" @click="SaveBtn('refuseForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="联系患者" :visible.sync="contactDialog" width="500px" :append-to-body="true" :z-index="99999">
      <div>
        <div style="background: linear-gradient(90deg, #f9f7df, #e3f5f3); border-radius: 4px; height: 60px; line-height: 60px; text-align: center; font-weight: bold; font-size: 18px; color: #333333">患者手机号：{{ detailInfo.patientName }} {{ detailInfo.phone }}</div>
        <div style="font-size: 14px; color: #fd403b; margin-top: 10px">* 电话接诊时长：一次15分钟，接诊完成后请点击“完成接诊”按钮</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contactDialog = false">取 消</el-button>
        <el-button type="primary" @click="complateBtn()">完成接诊</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import hdCom from '../../components/header'
import ChatHistory from "../../components/ChatHistory.vue";
import { DoctorAppointment } from "@/components/Drug/DoctorAppointment";
import { Chathub } from "../../components/Chathub/Chathub";
export default {
  components: {
    hdCom,
    ChatHistory,
  },
  data() {
    var doctorAppointment = new DoctorAppointment(this.TokenClient, this.Services.Drug);
    var userChat = new Chathub(this.TokenClient, this.Services.Chathub);
    return {
      DoctorAppointment: doctorAppointment,
      UserChat: userChat,
      detailInfo: {
        patientAnswerRecordDetailList: [],
      },
      weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      orderId: this.$route.query.orderId,
      infoType: "患者病历",
      active: 1,
      userLogo: "https://api.qyyl365.com/authorization/PC/userlogo.png",
      shopLogo: "https://api.qyyl365.com/authorization/PC/shoplogo.png",
      chatMessages: [
        // {
        //   sender: "other",
        //   senderName: "张三",
        //   content: "你好，这是昨天的会议记录",
        //   type: "text",
        //   timestamp: new Date().setDate(new Date().getDate() - 1),
        //   avatar: "",
        // },
        // {
        //   sender: "me",
        //   content: "收到了，谢谢分享",
        //   type: "text",
        //   timestamp: new Date().setDate(new Date().getDate() - 1) + 3600000,
        // },
        // {
        //   sender: "other",
        //   senderName: "张三",
        //   content: "https://example.com/document.pdf",
        //   type: "file",
        //   fileName: "会议记录.pdf",
        //   timestamp: new Date().setDate(new Date().getDate() - 1) + 7200000,
        //   avatar: "",
        // },
        // {
        //   sender: "me",
        //   content: "https://example.com/image.jpg",
        //   type: "image",
        //   timestamp: new Date().setHours(new Date().getHours() - 2),
        // },
      ],
      rules: {
        refuseReson: [{ required: true, message: "请填写拒绝接诊原因", trigger: "blur" }],
      },
      refuseForm: {
        id: 0,
        refuseReson: "",
      },
      refuseDialog: false,
      formLabelWidth: "15px",
      contactDialog: false,
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    handleClickYu(){
      this.$router.push({
        path: "/reservation/reservationOrderList",
        type:'3'
      });
    },
    handleChange(e) {
      // 加载问诊聊天记录
      if (this.infoType == "问诊过程") {
        this.GetDiseaseGroupHistoryChatMessageServer();
      }
    },
    getAge(data) {
      const birthDate = new Date(data);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    toRefund() {
      this.refuseDialog = true;
      this.refuseForm = {
        id: this.detailInfo.orderNumber,
        refusalReason: "",
      };
    },
    SaveBtn(formName) {
      var _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          var item = this.refuseForm;
          _this.DoctorAppointment.RefuseOrder(
            item.id,
            item.refuseReson,
            function (data) {
              _this.$message({
                type: "success",
                message: "操作成功!",
              });
              _this.$refs[formName].resetFields();
              _this.refuseDialog = false;
              _this.getList();
            },
            function (err) {
              var jsonObj = JSON.parse(err.msg);
              if (jsonObj.code == "400") {
                _this.$message({
                  type: "error",
                  message: jsonObj.msg,
                });
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    CloseBtn(formName) {
      this.$refs[formName].resetFields();
      this.refuseDialog = false;
    },
    complateBtn() {
      var _this = this;
      _this.DoctorAppointment.DoctorCompleteOrder(
        _this.detailInfo.orderNumber,
        function (data) {
          _this.$message({
            type: "success",
            message: "操作成功!",
          });
          _this.contactDialog = false;
          _this.getDetail();
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    toContact() {
      this.contactDialog = true;
    },
    toConfirm() {
      var _this = this;
      _this.DoctorAppointment.ConfirmOrder(
        _this.detailInfo.orderNumber,
        function (data) {
          _this.$message({
            type: "success",
            message: "操作成功!",
          });
          _this.getDetail();
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    handleClickBtn(e){
        this.$router.push({
          path: "/consultation/ConsultationList",
          query: {
              type: e,
          },
      });
    },
    // handleClickBtn(active) {
    //   if (this.active != active) {
    //     sessionStorage.removeItem("activeName");
    //   }
    //   this.active = active;
    //   sessionStorage.setItem("active", this.active);
    //   this.$router.push({
    //     path: "./ConsultationList",
    //     query: {},
    //   });
    // },
    formatWeek(date) {
      const d = new Date(date);
      return this.weekdays[d.getDay()];
    },
    getDetail() {
      var _this = this;
      _this.DoctorAppointment.OrderInfo(
        _this.orderId,
        function (data) {
          _this.detailInfo = data.data;
          if(_this.detailInfo.diseaseImage){
            _this.detailInfo.diseaseImage=JSON.parse(_this.detailInfo.diseaseImage)
          }
          _this.detailInfo?.patientAnswerRecordDetailList.map((res) => {
            res.userAnswer = JSON.parse(res.userAnswer);
          });
        },
        function (err) {}
      );
    },
    GetDiseaseGroupHistoryChatMessageServer(loadMore) {
      var _this = this;
      _this.UserChat.GetDiseaseGroupHistoryChatMessageServer(
        _this.detailInfo.userId,
        _this.orderId,
        function (data) {
          let messageList = [];
          let array = data.data;
          array?.forEach((item) => {
            if (!_this.chatMessages.some((i) => i.id == item.id)) {
              var text = _this.getMsgStr(item.contentType, item.content);
              var message = {
                id: item.id,
                groupId: item.groupId,
                FromUserId: item.fromUserId, //发送者
                To: item.toUser, //接收者，MsgType=USER时为用户ID，MsgType=GROUP时为群ID
                MsgType: item.msgType, //消息类型，同item.SessionType
                sender: item.fromUserId == _this.detailInfo.userId ? "other" : "me",
                img: item.fromUserId == _this.detailInfo.userId ? _this.userLogo : _this.shopLogo,
                senderName: item.fromUserId == _this.detailInfo.userId ? "患者" : "医生",
                timestamp: _this.timefilters(item.sendTime), //发送时间
                content: text, //正文
                Timestamp: _this.timeFormat(item.sendTime),
                type: item.contentType, //正文类型
              };
              messageList.push(message);
            }
          });
          if (messageList.length > 0) {
            if (_this.chatMessages.length == 0) {
              _this.chatMessages = messageList.concat(_this.chatMessages);
            } else {
              if (_this.chatMessages[0].Timestamp < messageList[0].Timestamp) {
                _this.chatMessages = _this.chatMessages.concat(messageList);
              } else {
                _this.chatMessages = messageList.concat(_this.chatMessages);
              }
            }
            if (loadMore) {
              _this.$nextTick(() => {
                _this.$refs.chatHistory.finishPullDown();
              });
            }
          }
        },
        function (err) {}
      );
    },
    getMsgStr(contentType, content) {
      var text = { text: `${content}` };
      if (contentType == "image") {
        text = { text: "<img style='max-width: 250px;min-width: 50px;width: 100%;margin: 10px 0;border: 1px solid #eee;overflow: hidden;border-radius: 5px;cursor: pointer;display: block;' src='" + `${this.Services.ossUpload}${content}` + "'/>" };
      } else if (contentType == "video") {
        text = { text: `<video style='max-width: 250px;min-width: 50px;width: 100%;margin: 10px 0;border: 1px solid #eee;overflow: hidden;border-radius: 5px;cursor: pointer;display: block;' width="745" height="420" controls="controls" data-src=${content} />` };
      } else if (contentType == "goods") {
        var msgInfo = JSON.parse(content);
        sessionStorage.setItem("goodsName", msgInfo.name);
        let img = msgInfo.coverImageUrls.indexOf(",") > -1 ? msgInfo.coverImageUrls.split(",")[0] : msgInfo.coverImageUrls;
        let img1 = `${this.Services.ossUpload}${img}`;
        text = {
          text: `<div style="width: 240px;height: auto;position: relative; color:#333;padding:10px 5px;cursor: pointer;" onclick="toGoods()"><div class="flex-start"><img object-fit='fill'style="width:60px;height:60px;margin-right:5px;object-fit: cover;border-radius: 10px;" src="${img1}"/><div style='display: flex;flex-direction: column;justify-content: space-between;align-items: flex-start;height:60px;'><div style='display: -webkit-box;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;-webkit-box-orient: vertical;line-height: 1.2;'>${msgInfo.name}</div><div style="color:red">${msgInfo.ordinaryPrice.toFixed(2)}</div></div></div></div>`,
        };
      } else if (contentType == "order") {
        var msgInfo = JSON.parse(content);
        sessionStorage.setItem("goodsOrder", msgInfo.sonOrderNumber);
        let strStart = `<div style="width: 300px; height: auto; position: relative; color: #333; padding: 5px; cursor: pointer" onclick="toGoodsOrder()">`;
        let strEnd = `<div style="height: 1px; background: #ebebeb; width: 100%; margin: 10px 0 5px"></div><div style="font-size: 12px; color: #999">订单编号：${msgInfo.sonOrderNumber}</div></div>`;
        let str = "";
        msgInfo.commodityList.forEach((item) => {
          let img1 = `${this.Services.ossUpload}${item.commoditySpecCoverImageUrls}`;
          let commodityName = item.commodityName;
          let ordinaryPrice = item.commodityMoney.toFixed(2);
          let commoditySpecName = item.commoditySpecName;
          let commodityNum = item.commodityNum;
          str += `<div class="flex-start" style='margin:10px 0'><img object-fit="fill" style="width: 80px; height: 80px; margin-right: 5px; object-fit: cover;border-radius: 10px;" src="${img1}" /><div style="width:100%;display: flex; flex-direction: column; justify-content: space-between; align-items: flex-start; height: 80px"><div style="display: -webkit-box;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;-webkit-box-orient: vertical;line-height: 1;">${commodityName}</div><div style='width:100%;display: flex;flex-direction: row;justify-content: space-between;align-items: center;color:#999'><div>${commoditySpecName}</div><div >x${commodityNum}</div></div><div style="color: red">${ordinaryPrice}</div></div></div>`;
        });
        text = {
          text: `${strStart}${str}${strEnd}`,
        };
      } else if (contentType == "doctorDesc") {
        var msgInfo = JSON.parse(content);
        let img1 = `https://oss.qyyl365.com/PC/touxiang.png`;
        if (msgInfo?.photoFile) {
          img1 = `${this.Services.ossUpload}${msgInfo?.photoFile}`;
        }
        let img2 = `https://oss.qyyl365.com/PC/yirenzheng.png`;
        text = {
          text: `<div style='padding: 0px 10px;background: #f5f7fa;border-radius: 6px;width: 300px;margin: 10px auto;'><div class="flex-start userInfo" style='margin: 5px 0;'><img style='width: 45px;height: 45px;border-radius: 50%;margin-right:5px' src="${img1}" /><div><div class="flex-start"><div style='font-weight: bold;margin-right: 5px;text-align: left;'>${msgInfo.doctorName} ${msgInfo.departmentName}</div><img style="margin-right: 5px" src="${img2}" /></div><div style='color: #666666;font-size: 12px;text-align: left;'>证书编号：${msgInfo.certificateNumber}</div></div></div><div class="desc twoLine" style='line-height: 1.4;font-size: 12px;text-align: left;' v-if="${msgInfo.profile}">简介:${msgInfo.profile}</div></div>`,
        };
      } else if (contentType == "caseCard") {
        var msgInfo = JSON.parse(content);
        let sex = `${msgInfo.sex ? "男" : "女"}`;
        let age = `${this.getAge(msgInfo?.birthday)}岁`;
        let birthday = `(${msgInfo.birthday?.split("T")[0]})`;
        let relationshipToPatient = "";
        switch (msgInfo.relationshipToPatient) {
          case 0:
            relationshipToPatient = "本人";
            break;
          case 1:
            relationshipToPatient = "子女";
            break;
          case 2:
            relationshipToPatient = "父母";
            break;
          case 3:
            relationshipToPatient = "其他";
            break;
        }
        text = {
          text: `<div class="box" style='padding: 0px 10px;background: #f5f7fa;border-radius: 6px;width: 300px;margin: 10px auto;'><div class="flex-space-between top-title" style='margin-bottom: 5px;'><h4 style="font-weight: 400;">病历卡</h4><div class="topRighgt-btn" style='color: #00afb5;font-size: 12px;'></div></div><div class="userInfo" style='margin: 5px 0;'><div class="doctor-1" style='font-weight: bold;margin-right: 5px;text-align: left;'>${msgInfo.patientName} ${msgInfo.departmentName}${sex} ${age}${birthday} ${relationshipToPatient}</div><div class="desc flex-start" style="text-align: left; margin: 5px 0; align-items: start;line-height: 1.4;font-size: 12px;text-align: left;"><div class="left-title" style='color: #999999;width: 60px;'>就诊疾病：</div><div class="right-val twoLine" style='width: calc(100% - 60px);'>${msgInfo.diseaseDiagnose}</div></div><div class="desc flex-start" style="text-align: left; align-items: start;line-height: 1.4;font-size: 12px;text-align: left;"><div class="left-title" style='color: #999999;width: 60px;'>病情描述：</div><div class="right-val twoLine" style='width: calc(100% - 60px);'>${msgInfo.description}</div></div></div></div>`,
        };
      }
      return text;
    },
    /**
     * 日期格式化
     * @param val
     */
    timefilters(val) {
      if (val == null || val == "") {
        return "-";
      } else {
        let d = new Date(val); //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times = d.getFullYear() + "-" + month + "-" + day + " " + hours + ":" + min + ":" + sec;
        return times;
      }
    },
    /**
     * 日期转时间戳
     * @param val
     */
    timeFormat(val) {
      const date = new Date(val); // 获取当前日期对象
      return date.getTime();
    },
    goBack() {
      var _this = this
      let payType = ''
      if (_this.detailInfo.state == '3' || _this.detailInfo.state == '4' || _this.detailInfo.state == '-1' || _this.detailInfo.state == '-2' || _this.detailInfo.state == '-3' ) {
        payType = '3,4,-1,-2,-3'
      }  else {
        payType = _this.detailInfo.state
      }
      _this.$router.push({
        path: "/consultation/ConsultationList",
        query: {
          type: _this.detailInfo.orderType,
          payType:payType
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.pageBox {
  text-align: center;
  margin-top: 10px;
}

.inteBox {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
}

.titleTop {
  padding: 0px 20px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.titleTopLeft {
  width: 85%;
  display: flex;
  align-items: center;
}

.titleTopLeftImg {
  width: 123px;
  height: 24px;
}

.titleTopLeftImg img {
  width: 100%;
  height: 100%;
}

.tabBox {
  padding-left: 12%;
  margin-top: 10px;
}

.el-tabs__item {
  height: 60px;
  color: white !important;
  text-align: center;
  padding-top: 10px;
  font-size: 25px !important;
  background-color: #00afb5 !important;
  border: none !important;
}

.is-active {
  color: white !important;
  background-color: #00afb5 !important;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: #ffffff !important;
}

.titleTopRight {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.titleTopRight div {
  margin-left: 10px;
}

.titleTopLine {
  width: 100%;
  height: 12px;
}

.titleTopCenter {
  width: 100%;
  /* height: 100; */
  display: flex;
}

.titleTopCenterLeft {
  width: 15%;
  background-color: #ffffff;
  /* padding-top: 30px; */
  // max-height: 750px;
  overflow: auto;
}
.left-btn1 {
  width: 150px;
  height: 40px;
  line-height: 40px;
  background: #06add7;
  border-radius: 6px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.left-btn2 {
  width: 150px;
  height: 40px;
  line-height: 40px;
  background: rgba(255, 255, 255, 0);
  border-radius: 6px;
  border: 1px solid #06afd3;
  color: #06add7;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}

.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}

.titleTopCenterCenter {
  width: 80%;
  border-radius: 6px;
  height: calc(100vh - 64px - 24px);
  overflow: auto;
}

.titleTopCenterCenterTop {
  background-color: #ffffff;
  // padding: 0 40px;
  /* padding-top: 10px;
  padding-bottom: 10px; */
  height: 100%;
  overflow-y: auto;
}

.flex-l {
  display: flex;
  align-items: center;
}

.flex-l-s {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.noflex-l-s {
  display: flex;
  justify-content: space-around;
}

.flex-l-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Content1Title {
  padding: 20px 0;
  padding-left: 0;
  font-size: 18px;
  height: calc(100% - 20px);
  /* font-weight: bold; */

  color: #333333;
  padding-bottom: 0;
  text-align: left;
}

.titleTopLeftTableC {
  color: #06add7;
  cursor: pointer;
}

.ageInput {
  width: 80%;
}

.typeChecked {
  font-size: 14px;
  color: #ffffff;
  padding: 0px 15px;
  text-align: center;
  background: #00afb5;
  border-radius: 6px;
  cursor: pointer;
}

.notypeChecked {
  background: #f3f9f9;
  border: 1px solid #b9dcdd;
  padding: 0px 15px;
  border-radius: 6px;
  color: #00afb5;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}

.table3Box {
  border: 1px solid #b9dcdd;
  border-radius: 6px;
  padding: 30px;
  margin-top: 10px;
}

.titleTopright1Line {
  border-bottom: 1px dashed #999999;
}

.titleTopright1 {
  font-size: 16px;
  color: #06add7;
}

.stepInput {
  width: 60%;
  margin-right: 10px;
}

.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}

.titleTopCenterLeftBoxno {
  font-size: 18px;
  color: #cccccc;
  border: 1px solid #cccccc;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}

.el-page-header {
  line-height: 73px;
  /* padding-left: 20px; */
}
.center-content {
  height: calc(100vh - 30px);
}
.iq-card-body {
  padding: 0 0 15px;
  height: auto;
  height: calc(100% - 20px) !important;
}
.table-top {
  width: 96%;
  margin: 0 auto;
}

.table-line {
  width: 100%;
  height: 6px;
  background: #f5f6f7;
  margin: 0 0 15px;
}

.table-content {
  padding: 0 30px;
  .top-bg {
    background: #f0f2f5;
    border-radius: 4px;
    padding: 20px 20px;
  }
  .top-info {
    background: #fff;
    padding: 15px 20px;
    border-radius: 10px;
    .t1 {
      margin-right: 30px;
    }

    .t2 {
    }
    .right-desc {
      font-weight: bold;
    }
    .right-i {
      margin-right: 10%;
    }

    .userName {
      margin-left: 10px;
      font-size: 20px;
      color: var(--base--Color);
    }

    .info-div {
      margin-top: 5px;
    }
  }
  .doctor-1 {
    font-weight: bold;
    margin-right: 5px;
  }
  .doctor-bg1 {
    margin-right: 5px;
  }
  .doctor-bg2 {
    background: #677aec;
    border-radius: 4px;
    color: #fff;
    font-size: 10px;
    margin-right: 5px;
    padding: 0 5px;
  }
  .hosptail {
    color: #666666;
  }
  .title {
    height: 60px;
    line-height: 60px;
    font-weight: bold;
  }
  .top-1 {
    margin-right: 3%;
  }
  .top-1 span:first-child {
    color: #999999;
  }
  .center-div {
    margin: 15px 0;
  }
  .doctor-bg3 {
    border-radius: 4px;
    border: 1px solid #00afb5;
    color: #00afb5;
    font-size: 10px;
    padding: 0 5px;
    margin-right: 5px;
  }
  .line-left {
    width: 4px;
    height: 16px;
    background: #666;
    margin-right: 5px;
  }
  .doctor-bottom {
    width: 320px;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 2px 10px;
    margin-top: 10px;
  }
  .small-line {
    width: 1px;
    height: 14px;
    background: #999999;
  }
}

.PrintBox {
  width: 600px;
  background: #ffffff;
  font-size: 14px;
  padding: 20px;
  page-break-after: always !important;
  color: #333333;
}

.PrintBoxTitle {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
}

.PrintBoxTitle1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.PrintBoxTitle2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.PrintBoxTitleLine {
  width: 100%;
  height: 1px;
  background: #666666;
  margin: 5px 0;
  // margin-top: -2px;
  margin-right: 10px;
}

.PrintBoxTitleLineD {
  margin: 15px 0;
  border-bottom: 1px dashed #999999;
}

.printBox {
  visibility: visible !important;
  background-color: #adadad;
  color: #333333;
}

.printBox2 {
  visibility: visible !important;
  color: #333333;
}

.printBox3 {
  visibility: visible !important;
  color: #333333;
}

.print-d {
  ::v-deep .printTab .el-table__body-wrapper .el-table__cell {
    padding: 2px 0 !important;
  }
}

.print-d {
  width: 90%;
  margin: 0 auto;
  background: #ffffff;
  font-size: 14px;

  .p-t {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    padding-top: 20px;
    color: #333333;
  }

  .oneLine {
    margin: 10px 0 0 0;
    border-bottom: 1px dashed #999999;
  }

  .oneLine2 {
    margin: 10px 0;
    border-bottom: 1px solid #999999;
  }

  .twoLine {
    margin: 10px 0;
    height: 3px;
    border-top: 1px dashed #999999;
    border-bottom: 1px dashed #999999;
  }
}

.text-r {
  text-align: right;
}
.el-radio-group /deep/ label:first-child {
  border-radius: 8px 0px 0px 8px;
}
.el-radio-group /deep/ label:last-child {
  border-radius: 0px 8px 8px 0px;
}
</style>
